import { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import axios from "axios";
import { API } from "../config/apiConfig";
import "./LoginPage.css";

const ResetPasswordPage = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const token = searchParams.get("token") || "";

  const [form, setForm] = useState({ password: "", confirmPassword: "" });
  const [error, setError] = useState("");
  const [success, setSuccess] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleChange = (event) => {
    setForm((prev) => ({ ...prev, [event.target.name]: event.target.value }));
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setError("");

    if (!token) {
      setError("Link de redefinição inválido. Solicite um novo link.");
      return;
    }

    if (form.password.length < 5) {
      setError("A senha deve ter no mínimo 5 caracteres.");
      return;
    }

    if (form.password !== form.confirmPassword) {
      setError("As senhas não coincidem.");
      return;
    }

    setLoading(true);
    try {
      await axios.post(API.AUTH.RESET_PASSWORD, {
        token,
        password: form.password,
      });
      setSuccess(true);
    } catch (err) {
      setError(
        err?.response?.data?.message ||
          "Não foi possível redefinir sua senha. O link pode ter expirado."
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <main className="auth-redesign">
      <div className="auth-redesign__bg-orb auth-redesign__bg-orb--one" />
      <div className="auth-redesign__bg-orb auth-redesign__bg-orb--two" />

      <div className="auth-redesign__layout">
        <section className="auth-story">
          <img
            src="/assets/favicon.png"
            alt="Logo"
            className="w-16 -mb-2 -mt-3"
          />
          <h1>Conecte anunciantes rurais e compradores reais</h1>
          <p>
            Publique produtos do campo, receba contatos de interessados e
            acompanhe oportunidades de venda em um só lugar.
          </p>

          <div className="auth-story__metrics">
            <article className="metric-card">
              <strong>+3.200</strong>
              <span>anúncios rurais ativos</span>
            </article>
            <article className="metric-card">
              <strong>12 estados</strong>
              <span>compradores buscando fornecedores locais</span>
            </article>
            <article className="metric-card">
              <strong>Contato</strong>
              <span>negociação simples entre anunciante e comprador</span>
            </article>
          </div>
        </section>

        <section className="auth-card-v2 fade-in">
          <div className="auth-card-v2__header">
            <h2>Defina sua nova senha</h2>
            <p>Escolha uma nova senha para acessar sua conta.</p>
          </div>

          {success ? (
            <div className="auth-card-v2__form">
              <div className="alert alert--success">
                Sua senha foi redefinida com sucesso. Agora você já pode
                entrar com a nova senha.
              </div>
              <button
                className="button button--primary !shadow-sm"
                type="button"
                onClick={() => navigate("/login")}
              >
                Ir para o login
              </button>
            </div>
          ) : (
            <form onSubmit={handleSubmit} className="auth-card-v2__form">
              {!token ? (
                <div className="alert">
                  Link de redefinição inválido ou incompleto. Solicite um novo
                  link na tela de recuperação de senha.
                </div>
              ) : null}

              <div className="field">
                <label className="label">Nova senha</label>
                <input
                  className="input"
                  name="password"
                  type="password"
                  value={form.password}
                  onChange={handleChange}
                  placeholder="Crie uma nova senha"
                  minLength={5}
                  required
                />
              </div>

              <div className="field">
                <label className="label">Confirmar nova senha</label>
                <input
                  className="input"
                  name="confirmPassword"
                  type="password"
                  value={form.confirmPassword}
                  onChange={handleChange}
                  placeholder="Repita a nova senha"
                  required
                />
              </div>

              {error ? <div className="alert">{error}</div> : null}

              <button
                className="button button--primary !shadow-sm"
                type="submit"
                disabled={loading || !token}
              >
                {loading ? "Salvando..." : "Salvar nova senha"}
              </button>

              <p className="auth-card-v2__back-link">
                <Link to="/login">Voltar para o login</Link>
              </p>
            </form>
          )}
        </section>
      </div>
    </main>
  );
};

export default ResetPasswordPage;
